// calculate for CONSTANTS.TIMEZONE
const dateString: string = new Date().toString();
const timezoneString: string = dateString.substring(dateString.lastIndexOf("("));

export enum Region {
  US_EAST_1 = "us-east-1",
  US_WEST_2 = "us-west-2",
}

export enum Environments {
  LOCAL = "local",
  ALPHA = "alpha",
  BETA = "beta",
  GAMMA = "gamma",
  PROD = "prod",
}

const CONSTANTS = {
  ALPHA_HOSTNAME: "alpha.claims.risk.amazon.dev",
  BETA_HOSTNAME: "beta.claims.risk.amazon.dev",
  PREPROD_HOSTNAME: "gamma.claims.risk.amazon.dev",
  PROD_HOSTNAME: "claims.risk.amazon.dev",

  REALM: {
    USAmazon: "USAmazon",
  },
  APPLICATION_NAME: {
    Claims: "Claims Home",
    ClaimMetricsSiteName: "Nucleus",
    ClaimsMetricsServiceName: "WcClaimIntake",
  },
  TIMEZONE: timezoneString,
  REGION_TO_AIRPORT_CODE_MAP: {
    [Region.US_EAST_1]: "IAD",
    [Region.US_WEST_2]: "PDX",
  },
};
export const CLOUDFRONT_HOSTNAMES = {
  ALPHA: "d1ro0heo2omuiu.cloudfront.net",
  BETA: "d1q4u35dloedn8.cloudfront.net",
  GAMMA: "d3ueue0qdb4sz1.cloudfront.net",
  PROD: "d23c8hv4ar5dz9.cloudfront.net",
};

export default CONSTANTS;
